module.exports = __webpack_public_path__ + "img/pbt_photo_02.da204a86.jpg";